import { FC, useEffect, useState } from 'react';
import DropdownAutocomplete from 'view/components/DropdownAutocomplete';
import { useGetJobPosts } from 'view/pages/candidates/hooks/useGetJobPosts';
import { useNavigate } from 'react-router';
import { StatusBlock, StatusBlockType } from 'view/components';

const JobPostsDropdownAutocomplete: FC<any> = ({
  label = 'My Job Posts',
  setValue,
  jobPostsValue,
  getJobPostInfoById,
  marginbottom = 0.1,
  jobSeekerId = null,
}) => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState('');
  const params = new URLSearchParams(window.location.search);
  const jobPostId: any = params.get('jobPostId');

  useEffect(() => {
    if (!jobPostsValue) setInputValue('');
  }, [jobPostsValue]);

  const { data: jobPostsData, isLoading: isJobPostsDataLoading } = useGetJobPosts(jobSeekerId);

  useEffect(() => {
    if (!jobPostsData?.results?.length && isJobPostsDataLoading && !jobPostId) return;
    const filteredItems = jobPostsData?.results?.filter((item) => {
      return item.id === +jobPostId;
    });
    if (filteredItems?.length) setValue(filteredItems[0]);
  }, [jobPostId, jobPostsData]);

  return (
    <DropdownAutocomplete
      label={label}
      value={jobPostsValue}
      onChange={(value: any) => {
        if (window.location.pathname === '/candidates/candidates-list') {
          const params = new URLSearchParams(window.location.search);
          params.set('jobPostId', value.id);
          navigate({
            pathname: window.location.pathname,
            search: `?${params.toString()}`,
          });
        }
        getJobPostInfoById(value.id);
        return setValue(value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      data={jobPostsData?.results?.length > 0 ? jobPostsData?.results : []}
      isLoading={isJobPostsDataLoading}
      getOptionLabel={(option: any) => {
        return `${option?.jobTitle}`;
      }}
      getOptionDisabled={(option: any) => {
        return option?.applicationStatus?.statusForRecruiter === 'Denied';
      }}
      renderOptionEnd={(option: any) => {
        if (!option?.applicationStatus) {
          return null;
        }
        return (
          <>
            <StatusBlock appStatus={option.applicationStatus.statusForRecruiter} />
            {option.applicationStatus.type === 'INVITE' && <StatusBlockType />}
          </>
        );
      }}
      marginbottom={marginbottom}
    />
  );
};

export default JobPostsDropdownAutocomplete;
